import { Injectable } from '@angular/core';

import { mergeMap } from 'rxjs/operators';

import { Actions, createEffect, ofType } from '@ngrx/effects';

import { Device, DeviceService } from '@era/gateway-sdk';
import { DevicesService } from '@rocksoft/mdm-sdk-v2';

import {
  UnenrolledDeviceResolverActions,
  UnenrolledDeviceApiActions,
  UnenrolledDeviceViewActions,
} from './unenrolled-device.actions';
import { safeMap } from '../effects.helpers';

@Injectable()
export class UnenrolledDeviceEffects {
  constructor(
    private readonly deviceService: DeviceService,
    private readonly devicesService: DevicesService,
    private readonly actions$: Actions
  ) {}

  appleDeviceLoadedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UnenrolledDeviceResolverActions.unenrolledDevicesRequested),
      mergeMap(() =>
        safeMap(
          this.deviceService.getUnenrolledDevices(),
          (unenrolledDevices: Device[]) => UnenrolledDeviceApiActions.unenrolledDevicesLoaded({ unenrolledDevices }),
          (error) => UnenrolledDeviceApiActions.unenrolledDevicesLoadedError({ error })
        )
      )
    );
  });

  unenrolledDevicesDeletedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UnenrolledDeviceViewActions.unenrolledDevicesDeleteRequested),
      mergeMap(({ unenrolledDeviceIds }) =>
        safeMap(
          this.devicesService.deleteDevices(unenrolledDeviceIds, '2.0'),
          () => UnenrolledDeviceViewActions.unenrolledDevicesDeleted(),
          (error) => UnenrolledDeviceApiActions.unenrolledDevicesDeletedError({ error })
        )
      )
    );
  });
}
